module.exports = __webpack_public_path__ + "03_medium_brown.3933477d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_medium_brown.png
// module id = SkpH
// module chunks = 0